var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrdersImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 450.333,
    height: 335.552,
    viewBox: "0 0 450.333 335.552",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Reading_list-rafiki",
    "data-name": "Reading list-rafiki",
    transform: "translate(0 -55)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-10",
    transform: "translate(0 55)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_97",
    "data-name": "Rect\\xE1ngulo 97",
    width: 450.333,
    height: 0.225,
    transform: "translate(0 294.878)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_98",
    "data-name": "Rect\\xE1ngulo 98",
    width: 13.42,
    height: 0.225,
    transform: "translate(391.79 309.37)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_99",
    "data-name": "Rect\\xE1ngulo 99",
    width: 7.827,
    height: 0.225,
    transform: "translate(290.492 311.82)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_100",
    "data-name": "Rect\\xE1ngulo 100",
    width: 30.794,
    height: 0.225,
    transform: "translate(357.195 301.012)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_101",
    "data-name": "Rect\\xE1ngulo 101",
    width: 38.9,
    height: 0.225,
    transform: "translate(59.84 305.659)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_102",
    "data-name": "Rect\\xE1ngulo 102",
    width: 14.032,
    height: 0.225,
    transform: "translate(106.756 305.659)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_103",
    "data-name": "Rect\\xE1ngulo 103",
    width: 84.374,
    height: 0.225,
    transform: "translate(145.079 302.633)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_78",
    "data-name": "Trazado 78",
    d: "M217.253,309.708H43.344a5.143,5.143,0,0,1-5.134-5.143V60.1A5.143,5.143,0,0,1,43.344,55h173.91a5.143,5.143,0,0,1,5.143,5.143V304.566A5.143,5.143,0,0,1,217.253,309.708ZM43.344,55.18A4.918,4.918,0,0,0,38.435,60.1V304.566a4.918,4.918,0,0,0,4.909,4.918h173.91a4.927,4.927,0,0,0,4.918-4.918V60.1a4.927,4.927,0,0,0-4.918-4.918Z",
    transform: "translate(-3.796 -55)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_79",
    "data-name": "Trazado 79",
    d: "M433.561,309.708H259.643a5.152,5.152,0,0,1-5.143-5.143V60.1a5.152,5.152,0,0,1,5.143-5.1H433.561a5.143,5.143,0,0,1,5.125,5.1V304.566A5.143,5.143,0,0,1,433.561,309.708ZM259.643,55.18a4.927,4.927,0,0,0-4.918,4.918V304.566a4.927,4.927,0,0,0,4.918,4.918H433.561a4.927,4.927,0,0,0,4.918-4.918V60.1a4.927,4.927,0,0,0-4.918-4.918Z",
    transform: "translate(-25.28 -55)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_104",
    "data-name": "Rect\\xE1ngulo 104",
    width: 16.77,
    height: 115.168,
    transform: "translate(209.945 294.878) rotate(180)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_80",
    "data-name": "Trazado 80",
    d: "M220.378,379.986H214.47V358.1h12.1Z",
    transform: "translate(-21.304 -85.108)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_105",
    "data-name": "Rect\\xE1ngulo 105",
    width: 16.77,
    height: 115.168,
    transform: "translate(387.304 294.878) rotate(180)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_106",
    "data-name": "Rect\\xE1ngulo 106",
    width: 182.511,
    height: 109.197,
    transform: "translate(375.686 288.898) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_81",
    "data-name": "Trazado 81",
    d: "M409.878,379.986h5.908V358.1h-12.1Z",
    transform: "translate(-40.1 -85.108)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_107",
    "data-name": "Rect\\xE1ngulo 107",
    width: 90.328,
    height: 54.103,
    transform: "translate(315.512 279.08) rotate(-90)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_82",
    "data-name": "Trazado 82",
    d: "M373.045,267.584h10.709A18.166,18.166,0,0,0,396.048,263H360.76A18.139,18.139,0,0,0,373.045,267.584Z",
    transform: "translate(-35.836 -75.661)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_108",
    "data-name": "Rect\\xE1ngulo 108",
    width: 90.328,
    height: 54.103,
    transform: "translate(257.374 279.08) rotate(-90)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_83",
    "data-name": "Trazado 83",
    d: "M307.894,267.584h10.7A18.166,18.166,0,0,0,330.888,263H295.6a18.166,18.166,0,0,0,12.294,4.584Z",
    transform: "translate(-29.363 -75.661)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_109",
    "data-name": "Rect\\xE1ngulo 109",
    width: 90.328,
    height: 54.103,
    transform: "translate(199.245 279.08) rotate(-90)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_84",
    "data-name": "Trazado 84",
    d: "M243.344,267.584h10.7A18.149,18.149,0,0,0,266.338,263H231.05a18.166,18.166,0,0,0,12.294,4.584Z",
    transform: "translate(-22.951 -75.661)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_110",
    "data-name": "Rect\\xE1ngulo 110",
    width: 114.439,
    height: 257.248,
    transform: "translate(177.467 294.878) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_111",
    "data-name": "Rect\\xE1ngulo 111",
    width: 112.025,
    height: 257.248,
    transform: "translate(175.053 294.878) rotate(180)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_112",
    "data-name": "Rect\\xE1ngulo 112",
    width: 245.576,
    height: 98.371,
    transform: "translate(168.226 43.466) rotate(90)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_85",
    "data-name": "Trazado 85",
    d: "M167.332,151.042h0a26.822,26.822,0,0,0-26.822-26.822h-25.4A26.822,26.822,0,0,0,88.29,151.042Z",
    transform: "translate(-8.77 -61.876)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_113",
    "data-name": "Rect\\xE1ngulo 113",
    width: 58.669,
    height: 79.033,
    transform: "translate(158.562 215.106) rotate(90)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_114",
    "data-name": "Rect\\xE1ngulo 114",
    width: 34.865,
    height: 101.856,
    transform: "translate(123.697 105.675)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_115",
    "data-name": "Rect\\xE1ngulo 115",
    width: 34.865,
    height: 101.856,
    transform: "translate(79.52 105.675)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_86",
    "data-name": "Trazado 86",
    d: "M100.509,227.881H86.234A2.216,2.216,0,0,1,84,225.666h0a2.216,2.216,0,0,1,2.216-2.216h14.276a2.225,2.225,0,0,1,2.216,2.216h0a2.216,2.216,0,0,1-2.2,2.216Z",
    transform: "translate(-8.344 -71.733)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_116",
    "data-name": "Rect\\xE1ngulo 116",
    width: 245.576,
    height: 1.774,
    transform: "translate(71.621 43.466) rotate(90)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_117",
    "data-name": "Rect\\xE1ngulo 117",
    width: 121.356,
    height: 113.844,
    transform: "translate(371.21 151.474) rotate(180)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_118",
    "data-name": "Rect\\xE1ngulo 118",
    width: 121.356,
    height: 113.844,
    transform: "translate(368.156 151.474) rotate(180)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_119",
    "data-name": "Rect\\xE1ngulo 119",
    width: 131.506,
    height: 6.593,
    transform: "translate(371.21 158.067) rotate(180)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_120",
    "data-name": "Rect\\xE1ngulo 120",
    width: 124.733,
    height: 6.593,
    transform: "translate(360.996 158.067) rotate(180)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_121",
    "data-name": "Rect\\xE1ngulo 121",
    width: 102,
    height: 110.377,
    transform: "translate(362.662 43.547) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_122",
    "data-name": "Rect\\xE1ngulo 122",
    width: 102,
    height: 6.116,
    transform: "translate(310.532 43.547) rotate(90)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_123",
    "data-name": "Rect\\xE1ngulo 123",
    width: 102,
    height: 2.315,
    transform: "translate(254.6 43.556) rotate(90)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_124",
    "data-name": "Rect\\xE1ngulo 124",
    width: 102,
    height: 2.315,
    transform: "translate(312.846 43.547) rotate(90)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_87",
    "data-name": "Trazado 87",
    d: "M295.189,218.3c-2.234-23.129-3.783-60.651-2.576-73.206a1.513,1.513,0,0,1,.621-1.081h0a1.549,1.549,0,0,1,2.459,1.288c-.216,6.224-.459,21.769.9,48.582.657,13.348,1.612,22.517.955,24.417Z",
    transform: "translate(-29.025 -63.813)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_88",
    "data-name": "Trazado 88",
    d: "M282.6,166.021c-6.3-7.061-19.328-12.078-32.559-12.051-5.188,0,15.8,8.205,24.525,17.257,6.782,7.025,14.411,18.851,17.032,25.417C289.913,182.818,288.958,173.073,282.6,166.021Z",
    transform: "translate(-24.757 -64.831)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_89",
    "data-name": "Trazado 89",
    d: "M299.762,168.235c5.278-7.349,17.464-13.006,30.623-13.645,5.179-.252-14.51,9.007-21.859,18.428-5.71,7.34-11.565,19.508-13.168,26.173C295.016,185.347,294.484,175.584,299.762,168.235Z",
    transform: "translate(-29.319 -64.892)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_90",
    "data-name": "Trazado 90",
    d: "M282.883,137.615c-5.4-5.98-16.374-10.232-27.569-10.2-4.4,0,13.375,6.953,20.769,14.609,5.737,5.953,12.213,15.969,14.411,21.526C289.044,151.854,288.233,143.586,282.883,137.615Z",
    transform: "translate(-25.293 -62.193)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_91",
    "data-name": "Trazado 91",
    d: "M297.379,147.275c4.5-6.224,14.789-11.015,25.948-11.556,4.377-.207-12.294,7.6-18.509,15.609-4.837,6.215-9.79,16.518-11.159,22.165C293.335,161.767,292.912,153.5,297.379,147.275Z",
    transform: "translate(-29.152 -63.018)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_92",
    "data-name": "Trazado 92",
    d: "M294.951,250.947h0a13.15,13.15,0,0,1-13.078-12.384l-1.153-20.1h28.551l-1.162,20.1A13.141,13.141,0,0,1,294.951,250.947Z",
    transform: "translate(-27.885 -71.237)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_93",
    "data-name": "Trazado 93",
    d: "M310.762,222.607H278.509l-.919-8.367h34.09Z",
    transform: "translate(-27.574 -70.818)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-10",
    transform: "translate(50.536 370.161)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-10",
    cx: 174.63,
    cy: 10.196,
    rx: 174.63,
    ry: 10.196,
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-10",
    transform: "translate(129.094 87.021)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_94",
    "data-name": "Trazado 94",
    d: "M252.775,403.539l-7.521.847-2.774-17.059L250,386.48Z",
    transform: "translate(-153.18 -119.948)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_95",
    "data-name": "Trazado 95",
    d: "M290.256,405.322h-7.512L280.88,387.93h7.512Z",
    transform: "translate(-156.995 -120.092)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_96",
    "data-name": "Trazado 96",
    d: "M280.735,406.27h9.151a.658.658,0,0,1,.639.513l1.486,6.674a1.1,1.1,0,0,1-1.1,1.333c-2.945-.045-5.1-.216-8.809-.216-2.279,0-9.16.234-12.312.234s-3.6-3.116-2.27-3.4c5.782-1.27,10.142-3.017,12-4.683A1.8,1.8,0,0,1,280.735,406.27Z",
    transform: "translate(-155.598 -121.914)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_97",
    "data-name": "Trazado 97",
    d: "M243.876,404.83l8.106-.9a.649.649,0,0,1,.694.441l2.225,6.458a1.09,1.09,0,0,1-.9,1.45c-2.945.288-7.205.594-10.907,1.018-4.323.486-5.044,1.648-10.132,1.522-3.089-.072-3.873-3.206-2.576-3.459,5.908-1.144,7.043-2.036,11.709-5.719a3.44,3.44,0,0,1,1.783-.811Z",
    transform: "translate(-151.919 -121.681)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_98",
    "data-name": "Trazado 98",
    d: "M244.924,161.277c-2.522,2.081-5.008,3.891-7.575,5.746s-5.188,3.6-7.89,5.251-5.467,3.26-8.376,4.71a60.618,60.618,0,0,1-9.241,3.882c-.838.261-1.657.486-2.6.712a25.1,25.1,0,0,1-2.8.45c-1.693.189-3.278.261-4.864.342-3.161.144-6.3.135-9.367.117-6.2-.072-12.339-.369-18.518-.9l-.09-5.638c6.061-.775,12.15-1.45,18.175-2.126,3.008-.333,6.016-.694,8.944-1.081,1.468-.2,2.918-.432,4.251-.684a17.26,17.26,0,0,0,1.711-.4c.522-.18,1.171-.387,1.8-.63a61.433,61.433,0,0,0,7.485-3.657c2.495-1.432,4.981-2.972,7.43-4.6s4.891-3.323,7.313-5.044,4.828-3.549,7.1-5.278Z",
    transform: "translate(-146.338 -96.701)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_99",
    "data-name": "Trazado 99",
    d: "M257.99,153.936c-1.081,7.1-16.023,17.95-16.023,17.95l-10.727-13.3a178.053,178.053,0,0,1,14.924-14.195C250.983,140.444,259.161,146.209,257.99,153.936Z",
    transform: "translate(-152.064 -95.773)",
    fill: "#ff3838"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_100",
    "data-name": "Trazado 100",
    d: "M175.378,178.845l-4.26-3.035-.468,9.592s2.36,0,3.269-1.729Z",
    transform: "translate(-146.045 -99.021)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_101",
    "data-name": "Trazado 101",
    d: "M166.794,172.71l-.874,9.394,4.26,2.99.468-9.592Z",
    transform: "translate(-145.575 -98.714)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_102",
    "data-name": "Trazado 102",
    d: "M242.49,387.337l1.423,8.791,7.521-.847-1.423-8.791Z",
    transform: "translate(-153.181 -119.949)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_103",
    "data-name": "Trazado 103",
    d: "M288.392,387.93H280.88l.964,8.971h7.512Z",
    transform: "translate(-156.995 -120.092)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104",
    "data-name": "Trazado 104",
    d: "M284.463,144.477a4.287,4.287,0,0,1,3.224,5.233,176.413,176.413,0,0,0-3.675,20.526c-.712,5.818-1.135,11.375-1.4,16.41-.63,11.8-.369,20.8-.721,23.85l-40.071-2.774c-4.071-31.884.694-52.239,3.378-60.5a7.151,7.151,0,0,1,5.854-4.9c1.54-.2,3.377-.4,5.323-.513.676,0,1.369-.063,2.063-.081a148.971,148.971,0,0,1,17.05,1.144c1.072.126,2.153.288,3.206.45C280.8,143.693,282.806,144.108,284.463,144.477Z",
    transform: "translate(-152.958 -95.636)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_105",
    "data-name": "Trazado 105",
    d: "M277.078,121.61c-1.459,5.4-3.233,15.365.342,19.292-9.286,6.251-15.212,15.041-16.924,13.132-.9-1-1.279-12.609-.108-14.321,6.215-1.036,6.377-5.575,5.611-9.907Z",
    transform: "translate(-154.886 -93.638)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_106",
    "data-name": "Trazado 106",
    d: "M276.693,140.54s-15.14,6.7-17.113,21.67c4.161-4.828,13.375-10.078,13.375-10.078l-4.062-1.162a41.492,41.492,0,0,1,7.98-2.153c-.45-2.072,1.954-6.2,1.954-6.2Z",
    transform: "translate(-154.879 -95.518)",
    fill: "#ff3838"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107",
    "data-name": "Trazado 107",
    d: "M262.545,140.27s2.009,8.556-3.486,21.913c-.856-5.1-4.449-13.627-4.449-13.627l3.711,1s-.189-1.72-3.188-4.017c1.117-2.144,4.611-4.674,4.611-4.674Z",
    transform: "translate(-154.385 -95.491)",
    fill: "#ff3838"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_108",
    "data-name": "Trazado 108",
    d: "M273.277,125.32l-6.557,4.846a17.114,17.114,0,0,1,.315,3.062c2.36-.171,5.746-2.513,6.161-4.945a8.178,8.178,0,0,0,.081-2.963Z",
    transform: "translate(-155.588 -94.006)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_109",
    "data-name": "Trazado 109",
    d: "M257.2,104.23c-3.666.153-5.683,6.467-1.972,11.709S262.131,104.023,257.2,104.23Z",
    transform: "translate(-154.251 -91.911)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_110",
    "data-name": "Trazado 110",
    d: "M275.39,109.331c.432,7.44,1.063,11.772-2.207,16-4.927,6.377-14.456,4.1-17.113-3.062-2.378-6.449-2.7-17.536,4.188-21.337a10.168,10.168,0,0,1,15.131,8.394Z",
    transform: "translate(-154.377 -91.455)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_111",
    "data-name": "Trazado 111",
    d: "M276.074,114.139c-5.638-3.6-7.629-8.349-8.061-10.736-2.189.513-13.051,5.512-16.392,0s.9-8.754,7.115-5.359c-2.765-4.882-.252-7.268,8.439-7.485s7.521,4.828,7.521,4.828,6.575-2.864,8.908,2.18C286.3,103.367,281.325,113.265,276.074,114.139Z",
    transform: "translate(-153.972 -90.553)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_112",
    "data-name": "Trazado 112",
    d: "M275.72,94.115c.081,0,3.287.775,6.989-2.945-.657,3.17-6.4,5.287-6.4,5.287Z",
    transform: "translate(-156.482 -90.614)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_113",
    "data-name": "Trazado 113",
    d: "M279.8,106.511c-3.459-1.2-7.656,3.936-6.107,10.132S284.474,108.123,279.8,106.511Z",
    transform: "translate(-156.248 -92.12)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_114",
    "data-name": "Trazado 114",
    d: "M281.931,116.836a7.043,7.043,0,0,1-2.882,4.575c-2.035,1.423-3.873-.2-3.99-2.549-.108-2.117.829-5.4,3.2-5.89S282.3,114.566,281.931,116.836Z",
    transform: "translate(-156.416 -92.772)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_115",
    "data-name": "Trazado 115",
    d: "M252.092,299.582c1.8-21.958,15.041-82.762,15.041-82.762L240.789,215s-10.16,60.345-10.934,83.258c-.811,23.823,8.772,76.755,8.772,76.755l12.609-1.441S250.273,321.639,252.092,299.582Z",
    transform: "translate(-151.921 -102.914)",
    fill: "#ff3838"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_116",
    "data-name": "Trazado 116",
    d: "M252.092,299.582c1.8-21.958,15.041-82.762,15.041-82.762L240.789,215s-10.16,60.345-10.934,83.258c-.811,23.823,8.772,76.755,8.772,76.755l12.609-1.441S250.273,321.639,252.092,299.582Z",
    transform: "translate(-151.921 -102.914)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_117",
    "data-name": "Trazado 117",
    d: "M259.723,239.88c-5.314,6.791-5.4,30.623-3.35,48.258,1.954-12.717,5.035-28.821,7.746-42.331Z",
    transform: "translate(-154.437 -105.386)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_118",
    "data-name": "Trazado 118",
    d: "M257.78,216.08s2.846,64.29,6.016,86.059c3.468,23.841,12.285,75.989,12.285,75.989h13.753s-2.261-49.077-4.08-72.5c-2.063-26.678-2.117-87.707-2.117-87.707Z",
    transform: "translate(-154.7 -103.022)",
    fill: "#ff3838"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_119",
    "data-name": "Trazado 119",
    d: "M257.78,216.08s2.846,64.29,6.016,86.059c3.468,23.841,12.285,75.989,12.285,75.989h13.753s-2.261-49.077-4.08-72.5c-2.063-26.678-2.117-87.707-2.117-87.707Z",
    transform: "translate(-154.7 -103.022)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_120",
    "data-name": "Trazado 120",
    d: "M276.059,395.722h16.194v-4.837l-18.1-.315Z",
    transform: "translate(-156.326 -120.354)",
    fill: "#ff3838"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_121",
    "data-name": "Trazado 121",
    d: "M238.721,393.495l15.059-1.711-.549-4.864-16.86,1.648Z",
    transform: "translate(-152.573 -119.992)",
    fill: "#ff3838"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_122",
    "data-name": "Trazado 122",
    d: "M265.37,114.069c.072.6-.189,1.135-.585,1.18s-.766-.405-.847-1.009.189-1.126.585-1.171S265.3,113.475,265.37,114.069Z",
    transform: "translate(-155.31 -92.789)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_123",
    "data-name": "Trazado 123",
    d: "M257.842,114.979c.072.6-.189,1.126-.585,1.18s-.766-.405-.838-1.009.189-1.126.576-1.171S257.752,114.376,257.842,114.979Z",
    transform: "translate(-154.564 -92.879)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_124",
    "data-name": "Trazado 124",
    d: "M260.171,115.14a21.715,21.715,0,0,1-2.261,5.485,3.5,3.5,0,0,0,2.945.189Z",
    transform: "translate(-154.713 -92.995)",
    fill: "#ed847e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_125",
    "data-name": "Trazado 125",
    d: "M267.223,111.266a.351.351,0,0,1-.36-.09,2.846,2.846,0,0,0-2.4-.9.36.36,0,0,1-.459-.324.342.342,0,0,1,.288-.414,3.5,3.5,0,0,1,3.044,1.108.351.351,0,0,1,0,.5.415.415,0,0,1-.108.117Z",
    transform: "translate(-155.317 -92.435)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_126",
    "data-name": "Trazado 126",
    d: "M264.656,123.729h0a5.458,5.458,0,0,0,3.891-3.2.189.189,0,0,0-.108-.243.2.2,0,0,0-.252.117,5.161,5.161,0,0,1-3.6,2.945.193.193,0,0,0,.072.378Z",
    transform: "translate(-155.361 -93.505)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_127",
    "data-name": "Trazado 127",
    d: "M254.379,112.576a.3.3,0,0,1-.216,0,.36.36,0,0,1-.225-.45,3.549,3.549,0,0,1,2.3-2.3.351.351,0,0,1,.432.261.342.342,0,0,1-.252.423h0a2.828,2.828,0,0,0-1.8,1.8.324.324,0,0,1-.234.261Z",
    transform: "translate(-154.317 -92.466)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_128",
    "data-name": "Trazado 128",
    d: "M279.31,407.524a2.26,2.26,0,0,1-1.441-.387,1.063,1.063,0,0,1-.369-.9.549.549,0,0,1,.306-.5c.829-.432,3.251,1.063,3.522,1.234a.162.162,0,0,1,.081.18.171.171,0,0,1-.135.144,8.754,8.754,0,0,1-1.963.234Zm-1.117-1.558a.522.522,0,0,0-.225.045.216.216,0,0,0-.117.207.73.73,0,0,0,.243.648,3.69,3.69,0,0,0,2.7.135A7.269,7.269,0,0,0,278.193,405.966Z",
    transform: "translate(-156.659 -121.853)",
    fill: "#ff3838"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_129",
    "data-name": "Trazado 129",
    d: "M281.405,407.057a.162.162,0,0,1-.09,0c-.775-.423-2.279-2.072-2.117-2.9a.585.585,0,0,1,.567-.468.954.954,0,0,1,.757.225c.9.711,1.054,2.882,1.054,2.972a.143.143,0,0,1-.171.171Zm-1.486-3.044h-.072c-.234,0-.252.135-.261.18-.1.5.9,1.738,1.63,2.324a4.216,4.216,0,0,0-.9-2.351.621.621,0,0,0-.4-.153Z",
    transform: "translate(-156.827 -121.657)",
    fill: "#ff3838"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_130",
    "data-name": "Trazado 130",
    d: "M244.242,406.026h0c-1.171.378-3.278.9-4.179.279a.973.973,0,0,1-.423-.82.567.567,0,0,1,.234-.5c.847-.594,4.026.576,4.377.712a.189.189,0,0,1,.117.171.171.171,0,0,1-.126.162Zm-4.152-.775h0a.234.234,0,0,0-.09.207.639.639,0,0,0,.279.54c.5.36,1.738.288,3.359-.171-1.306-.405-3.026-.847-3.549-.576Z",
    transform: "translate(-152.898 -121.769)",
    fill: "#ff3838"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_131",
    "data-name": "Trazado 131",
    d: "M244.418,405.811a.2.2,0,0,1-.144,0c-.946-.3-2.909-1.711-2.864-2.567,0-.207.117-.468.594-.567a1.279,1.279,0,0,1,1.018.189c1.036.675,1.468,2.7,1.486,2.7a.2.2,0,0,1-.054.171Zm-2.531-2.7c-.117.063-.126.135-.126.171,0,.513,1.333,1.639,2.315,2.09a4.161,4.161,0,0,0-1.252-2.189.9.9,0,0,0-.739-.144.612.612,0,0,0-.2.063Z",
    transform: "translate(-153.074 -121.554)",
    fill: "#ff3838"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_132",
    "data-name": "Trazado 132",
    d: "M291.8,156.712c-.189,2.936-.531,5.665-.9,8.484s-.838,5.584-1.369,8.376a98.7,98.7,0,0,1-4.62,16.734l-.9,2.1-.225.522-.054.135-.09.2-.27.558a9.089,9.089,0,0,1-1.243,1.8,10.98,10.98,0,0,1-2.7,2.234,16.1,16.1,0,0,1-2.585,1.252,33.8,33.8,0,0,1-9.241,1.936,77.46,77.46,0,0,1-17.185-.639l.207-5.638,3.972-.45c1.333-.153,2.657-.36,3.972-.54,2.63-.387,5.233-.82,7.719-1.4a29.408,29.408,0,0,0,6.638-2.2,3.675,3.675,0,0,0,1.45-1.108c0-.135-.261.432.072-.468l.594-1.738a113.483,113.483,0,0,0,3.333-15.185c.432-2.612.793-5.251,1.153-7.9s.639-5.341.9-7.872Z",
    transform: "translate(-153.968 -97.045)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_133",
    "data-name": "Trazado 133",
    d: "M295.019,150.192c3.675,6.161.54,25.543.54,25.543l-19.274-3.6s-1.045-11.1,2.63-19.617C282.9,143.275,290.569,142.716,295.019,150.192Z",
    transform: "translate(-156.525 -95.965)",
    fill: "#ff3838"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_134",
    "data-name": "Trazado 134",
    d: "M238.247,212.244l-10.223-47.555a9.619,9.619,0,0,0-8.944-7.358H179.92a9.637,9.637,0,0,1,8.944,7.358l10.214,47.555a9.637,9.637,0,0,0,8.944,7.358h39.17a9.628,9.628,0,0,1-8.944-7.358Z",
    transform: "translate(-146.966 -97.186)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_135",
    "data-name": "Trazado 135",
    d: "M238.247,212.244l-10.223-47.555a9.619,9.619,0,0,0-8.944-7.358H179.92a9.637,9.637,0,0,1,8.944,7.358l10.214,47.555a9.637,9.637,0,0,0,8.944,7.358h39.17a9.628,9.628,0,0,1-8.944-7.358Z",
    transform: "translate(-146.966 -97.186)",
    fill: "#ff3838",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_125",
    "data-name": "Rect\\xE1ngulo 125",
    width: 11.204,
    height: 0.904,
    transform: "translate(16.672 128.594) rotate(-84.857)",
    fill: "#ff3838"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_126",
    "data-name": "Rect\\xE1ngulo 126",
    width: 4.692,
    height: 0.901,
    transform: "matrix(0.092, -0.996, 0.996, 0.092, 15.223, 138.66)",
    fill: "#ff3838"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_136",
    "data-name": "Trazado 136",
    d: "M177.909,157.33H217.07a8.223,8.223,0,0,0-8.025,7.358l-10.16,110.494a8.232,8.232,0,0,1-8.034,7.358H166.407a6.611,6.611,0,0,1-6.692-7.358l10.16-110.494a8.232,8.232,0,0,1,8.034-7.358Z",
    transform: "translate(-144.955 -97.186)",
    fill: "#ff3838"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_137",
    "data-name": "Trazado 137",
    d: "M182.536,288.18a6.611,6.611,0,0,0,6.692,7.358h-39.17a6.6,6.6,0,0,1-6.683-7.358Z",
    transform: "translate(-143.331 -110.184)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_138",
    "data-name": "Trazado 138",
    d: "M182.536,288.18a6.611,6.611,0,0,0,6.692,7.358h-39.17a6.6,6.6,0,0,1-6.683-7.358Z",
    transform: "translate(-143.331 -110.184)",
    fill: "#ff3838",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11",
    "data-name": "Grupo 11",
    transform: "translate(20.66 69.322)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_139",
    "data-name": "Trazado 139",
    d: "M203.911,170.726H177.359a1.441,1.441,0,0,1-1.45-1.6h0a1.8,1.8,0,0,1,1.747-1.6h26.507a1.441,1.441,0,0,1,1.45,1.6h0A1.8,1.8,0,0,1,203.911,170.726Z",
    transform: "translate(-167.226 -167.52)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_140",
    "data-name": "Trazado 140",
    d: "M202.995,180.346H176.488a1.441,1.441,0,0,1-1.459-1.6h0a1.8,1.8,0,0,1,1.747-1.6h26.507a1.441,1.441,0,0,1,1.459,1.6h0A1.8,1.8,0,0,1,202.995,180.346Z",
    transform: "translate(-167.139 -168.475)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_141",
    "data-name": "Trazado 141",
    d: "M195.631,189.976H175.609a1.441,1.441,0,0,1-1.45-1.6h0a1.8,1.8,0,0,1,1.747-1.6h20a1.441,1.441,0,0,1,1.459,1.6h0A1.8,1.8,0,0,1,195.631,189.976Z",
    transform: "translate(-167.053 -169.432)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_142",
    "data-name": "Trazado 142",
    d: "M181.52,199.647h-6.782a1.441,1.441,0,0,1-1.459-1.594h0a1.8,1.8,0,0,1,1.747-1.6h6.791a1.441,1.441,0,0,1,1.45,1.6h0a1.8,1.8,0,0,1-1.747,1.594Z",
    transform: "translate(-166.965 -170.394)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_143",
    "data-name": "Trazado 143",
    d: "M200.364,209.226H173.839a1.441,1.441,0,0,1-1.45-1.6h0a1.8,1.8,0,0,1,1.747-1.6h26.5a1.441,1.441,0,0,1,1.459,1.6h0A1.8,1.8,0,0,1,200.364,209.226Z",
    transform: "translate(-166.877 -171.344)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_144",
    "data-name": "Trazado 144",
    d: "M189.065,218.856H172.988a1.441,1.441,0,0,1-1.459-1.6h0a1.8,1.8,0,0,1,1.747-1.6h16.068a1.45,1.45,0,0,1,1.459,1.6h0A1.8,1.8,0,0,1,189.065,218.856Z",
    transform: "translate(-166.791 -172.301)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_145",
    "data-name": "Trazado 145",
    d: "M198.616,228.476H172.109a1.441,1.441,0,0,1-1.45-1.6h0a1.8,1.8,0,0,1,1.747-1.6h26.48a1.45,1.45,0,0,1,1.459,1.6h0A1.8,1.8,0,0,1,198.616,228.476Z",
    transform: "translate(-166.705 -173.256)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_146",
    "data-name": "Trazado 146",
    d: "M191.242,238.106h-20a1.441,1.441,0,0,1-1.459-1.6h0a1.8,1.8,0,0,1,1.747-1.6h20a1.441,1.441,0,0,1,1.459,1.6h0A1.8,1.8,0,0,1,191.242,238.106Z",
    transform: "translate(-166.617 -174.213)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_147",
    "data-name": "Trazado 147",
    d: "M177.149,247.736h-6.791a1.45,1.45,0,0,1-1.459-1.6h0a1.8,1.8,0,0,1,1.756-1.6h6.782a1.441,1.441,0,0,1,1.459,1.6h0A1.8,1.8,0,0,1,177.149,247.736Z",
    transform: "translate(-166.53 -175.17)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_148",
    "data-name": "Trazado 148",
    d: "M195.986,257.356h-26.5a1.441,1.441,0,0,1-1.459-1.6h0a1.8,1.8,0,0,1,1.747-1.6h26.507a1.441,1.441,0,0,1,1.45,1.6h0a1.8,1.8,0,0,1-1.747,1.6Z",
    transform: "translate(-166.444 -176.125)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_149",
    "data-name": "Trazado 149",
    d: "M184.676,266.986H168.608a1.441,1.441,0,0,1-1.459-1.6h0a1.8,1.8,0,0,1,1.747-1.6h16.068a1.441,1.441,0,0,1,1.459,1.6h0A1.8,1.8,0,0,1,184.676,266.986Z",
    transform: "translate(-166.356 -177.082)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_150",
    "data-name": "Trazado 150",
    d: "M194.236,276.647h-26.5a1.441,1.441,0,0,1-1.459-1.6h0a1.8,1.8,0,0,1,1.747-1.594h26.507a1.441,1.441,0,0,1,1.45,1.594h0a1.8,1.8,0,0,1-1.747,1.6Z",
    transform: "translate(-166.27 -178.042)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_151",
    "data-name": "Trazado 151",
    d: "M252.3,199.069l-5.755-5-2.7,9.2s5.845,3.17,7.863.261Z",
    transform: "translate(-153.315 -100.835)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_152",
    "data-name": "Trazado 152",
    d: "M239.683,193.67l-1.873,7.719,5.44,1.846,2.693-9.2Z",
    transform: "translate(-152.716 -100.796)",
    fill: "#ffc3bd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdersImg);
export default __webpack_public_path__ + "static/media/orders-img.d940aa4e3a9e933c76f238de31323b68.svg";
export { ForwardRef as ReactComponent };